module.exports = __webpack_public_path__ + "img/video-cover-buy.e1eddc74.png";